import Convert from "./Convert/Convert";
import Random from "./Random/Random";
import Sum from "./Sum/Sum";
import Difference from "./Difference/Difference";
import { types } from "./types";
import Assign from './Assign/Assign';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(
  action,
  showAlert,
  variables,
  setOpenVariable,
  variableRender,
  setField,
  disabled,
  outputVisible
) {
  // control of action name then return component
  switch (action.actionName) {
    case types.CONVERT:
      return (
        <Convert
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.RANDOM:
      return (
        <Random
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
        />
      );
    case types.SUM:
      return (
        <Sum
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.DIFFERENCE:
      return (
        <Difference
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
        />
      );
    case types.ASSIGN:
      return (
        <Assign
          action={action}
          showAlert={showAlert}
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          setField={setField}
          disabled={disabled}
          outputVisible={outputVisible}
        />
      )
    default: break;
  }
}

export default Actions;
